export default __webpack_public_path__ + "static/media/ISTP.f1d3a45e.svg";